// Honor of Kings game config — scaffold (unify Phase 4).
// hokdraftplan was forked from ygdraftplan and never fine-tuned: it reuses
// the Dota Captains Mode board layout as-is, with the HoK hero roster
// (Tencent CDN). Real HoK pick/ban order still needs fine-tuning —
// change board.* here when you do, no component edits needed.
import heroIdMap from './heroIdMap';

const hok = {
  id: 'hok',
  name: 'Honor of Kings',

  features: {
    gsi: false,        // no Game State Integration outside Dota
    maps: false,
    everyonePremium: false,  // mirrors hokdraftplan (yg-style tier enforcement)
  },

  // Dota CM layout, exactly as hokdraftplan currently behaves (not yet tuned)
  board: {
    positionCount: 24,
    radiantBans: [1, 2, 5, 10, 11, 19, 21],
    radiantPicks: [8, 14, 15, 18, 23],
    direBans: [3, 4, 6, 7, 12, 20, 22],
    direPicks: [9, 13, 16, 17, 24],
    largeBoxSequences: ['8', '9', '13', '14', '15', '16', '17', '18', '23', '24'],
  },

  teams: { a: 'Blue', b: 'Red' },

  heroes: {
    idMap: heroIdMap,  // empty — no OpenDota equivalent; lookups fall back to slug
    // HoK images are keyed by numeric ename in HeroData.imageUrl; this CDN
    // fallback only fires for heroes missing an imageUrl.
    imageCdn: 'https://game.gtimg.cn/images/yxzj/img201606/heroimg/',
    defaultImage: 'https://game.gtimg.cn/images/yxzj/img201606/heroimg/506/506.jpg',
    idSource: 'Tencent gtimg CDN',
  },

  // Placeholder, copied from hokdraftplan/src/firebase/config.js — that app
  // was never deployed. Create a Firebase project and fill these in before
  // deploying the hok target.
  firebaseProjectId: 'YOUR_PROJECT_ID',
  firebase: {
    apiKey: "YOUR_API_KEY",
    authDomain: "YOUR_PROJECT_ID.firebaseapp.com",
    projectId: "YOUR_PROJECT_ID",
    storageBucket: "YOUR_PROJECT_ID.appspot.com",
    messagingSenderId: "YOUR_SENDER_ID",
    appId: "YOUR_APP_ID"
  },
};

export default hok;
